import { PlatformClosingCta } from '../PlatformShared'

export default function PricingClosingCta({ data }) {
    return <PlatformClosingCta data={data} layout="center" />
}
